module.exports = __webpack_public_path__ + "img/28800.8cf9413e.jpg";